import React from 'react';

import LogoConlicitacao from 'assets/images/logo-conlicitacao-banner-branco.svg';
import { Container } from './styles';

interface ConlicitacaoPromoBannerProps {
  onClick: () => void;
}

const ConlicitacaoPromoBanner: React.FC<ConlicitacaoPromoBannerProps> = ({ onClick }) => (
  <Container className="d-flex flex-column flex-lg-row align-items-center justify-content-between">
    <img src={LogoConlicitacao} alt="Conlicitação" className="banner-logo" />
    <p className="banner-text">
      O mais completo banco de dados de avisos de licitações, editais e acompanhamentos de processos
      licitatórios do país.
    </p>
    <button type="button" className="banner-button" onClick={onClick}>
      Conheça o Conlicitação
    </button>
  </Container>
);

export default ConlicitacaoPromoBanner;
